import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type {
	AnalyticsEventPayload,
	EditorAnalyticsAPI,
	BaseEventPayload,
} from '@atlaskit/editor-common/analytics';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';

type TableEditorAnalyticsAPI = {
	analyticsCallback: (
		contentId: any,
		createAnalyticsEvent?: CreateUIAnalyticsEvent,
	) => EditorAnalyticsAPI;
};

const normalizePayload = (payload: BaseEventPayload) => {
	const typeMap = {
		operational: 'sendOperationalEvent',
		screen: 'sendScreenEvent',
		track: 'sendTrackEvent',
		ui: 'sendUIEvent',
	};

	return {
		//adding "type" and "source", as they're originally omitted but expected by createAnalyticsEvent
		data: {
			...payload,
			source: 'editorComponent',
		},
		type: typeMap[payload.eventType],
	};
};

export const editorAnalyticsAPI: TableEditorAnalyticsAPI = {
	analyticsCallback: (contentId, createAnalyticsEvent?: CreateUIAnalyticsEvent) => {
		const fireAnalyticsEvent = (payload: BaseEventPayload) => {
			if (
				// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				!process.env.REACT_SSR &&
				typeof window !== 'undefined' &&
				typeof window.requestAnimationFrame === 'function' &&
				createAnalyticsEvent
			) {
				window.requestAnimationFrame(() => {
					const analyticsPayload = normalizePayload(payload);
					if (contentId) {
						analyticsPayload.data.attributes = {
							...analyticsPayload.data.attributes,
							objectId: contentId,
						};
					}
					createAnalyticsEvent(analyticsPayload).fire();
				});
			}
		};

		const attachAnalyticsEvent = (payload: AnalyticsEventPayload) => {
			fireAnalyticsEvent(payload);

			return (_tr: Transaction) => {
				return true;
			};
		};

		return { attachAnalyticsEvent, fireAnalyticsEvent };
	},
};
